import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { UserActivityPeriod } from './user-activity-period';
export { UserActivityPeriod };
import { userActivityPeriodSchema } from '@schemas/business-objects/user-activity-period';
import { UserFormGroup } from './user-form-group';

export class UserActivityPeriodFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    periodStart: SchemaFormControl;
    requestCount: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
  };

  declare value: Partial<UserActivityPeriod>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(userActivityPeriodSchema, UserActivityPeriod, data, options);
  }

  get object(): UserActivityPeriod {
    return new UserActivityPeriod(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<UserActivityPeriod[]> {
    return UserActivityPeriod.find(filter);
  }

  static async findOne(filter?: any): Promise<UserActivityPeriod | null> {
    return UserActivityPeriod.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<UserActivityPeriod> {
    return UserActivityPeriod.findById(id, filter);
  }

  static async create(
    data: Partial<UserActivityPeriod>,
  ): Promise<UserActivityPeriod> {
    return UserActivityPeriod.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<UserActivityPeriod>,
  ): Promise<UserActivityPeriod> {
    return UserActivityPeriod.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return UserActivityPeriod.deleteById(id);
  }
}

export class UserActivityPeriodFormArray extends PersistedFormArray {
  readonly entityName = 'UserActivityPeriod' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(userActivityPeriodSchema, UserActivityPeriod, options);
  }

  protected override createItemGroup() {
    return new UserActivityPeriodFormGroup();
  }

  get array(): UserActivityPeriod[] {
    return this.controls.map(
      (group: UserActivityPeriodFormGroup) => group.object,
    );
  }
}

export class UserActivityPeriodPersistedArray extends PersistedArray<UserActivityPeriod> {
  readonly entityName = 'UserActivityPeriod' as const;

  constructor(options?: PersistedArrayOptions) {
    super(UserActivityPeriod, options);
  }
}
